<template>
    <div>
        <b-modal v-model="isVisible" hide-footer>
            <b-img
                :src="model && model.url"
                fluid
                alt="Responsive image"
            ></b-img>
            <br />
            <div>
                <b-button variant="warning" @click="deleteAttachment(model.id)"
                    >Delete</b-button
                >
            </div>
        </b-modal>

        <!-- <b-row>
            <b-col cols="4">
                <b-form-file id="uploadData" @change="uploadFile"></b-form-file>
            </b-col>
        </b-row> -->
        <b-modal
            v-model="showModal"
            id="add-attachments-modal"
            centered
            hide-footer
            title="File(s) Upload"
        >
            <b-row>
                <b-col sm="12" xl="8" v-if="this.filelist.length" v-cloak>
                    <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                    <b-list-group>
                        <b-list-group-item
                            class="d-inline-flex p-2"
                            v-for="(file, i) in filelist"
                            :key="i"
                        >
                            <!--file name input to rename the file before upload-->
                            <b-form-input
                                placeholder="File name..."
                                v-model="filelist[i].fileName"
                                required
                                @change="renameFile(i, filelist[i].fileName)"
                            />

                            <!--file extension-->
                            <span
                                class="d-inline-flex align-items-center text-muted ml-1 mr-3"
                                >.{{ filelist[i].extension }}</span
                            >

                            <!--remove file from list (and from upload)-->
                            <b-button
                                variant="outline-danger"
                                size="sm"
                                @click="remove(filelist.indexOf(file))"
                            >
                                <b-icon-trash></b-icon-trash>
                            </b-button>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <!--this column contains the file drop area-->
                <!--its width is automatically set based on existance of the file list column and breakpoint-->
                <b-col class="file-drop-column my-4 my-xl-0 p-0">
                    <div
                        class="file-drop-area bg-light"
                        @dragover="dragover"
                        @drop="drop"
                    >
                        <!--we need an actual file input in order to have the drag&drop functionality-->
                        <!--and the File object(s) containing the files dropped-->
                        <!--We keep it invisible because we want to display something different than a file input-->
                        <input
                            type="file"
                            name="file-input"
                            id="file-input"
                            class="file-input invisible"
                            @change="onChange"
                        />

                        <!--clicking on this label will trigger the clicked event on the file input-->
                        <!--this will cause the 'choose file' system dialog-->
                        <label
                            for="file-input"
                            class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5"
                        >
                            <p>
                                <b-icon-cloud-upload-fill
                                    font-scale="3"
                                ></b-icon-cloud-upload-fill>
                            </p>
                            <div>
                                <p class="mb-0">Drop your file(s) here</p>
                                <p class="mb-0">
                                    or
                                    <span class="text-info"
                                        >choose from computer</span
                                    >
                                </p>
                            </div>
                        </label>
                    </div>
                </b-col>
            </b-row>

            <div class="float-right mt-4">
                <b-button
                    variant="secondary"
                    @click="$bvModal.hide('add-attachments-modal')"
                    class="mr-3"
                >
                    Cancel
                </b-button>
                <b-button
                    type="submit"
                    :disabled="!filelist.length"
                    variant="success"
                    @click="onSubmit()"
                >
                    Upload file(s)
                </b-button>
            </div>
        </b-modal>
        <b-row>
            <b-col cols="4">
                <b-button variant="primary" @click="showModal = !showModal">
                    Upload Attachment(s)
                </b-button>
            </b-col>
        </b-row>

        <b-container fluid class="p-4 mt-4 bg-dark">
            <b-row>
                <b-col
                    v-for="(item, index) in cleanedAttachments"
                    :key="index"
                    md="3"
                    class="mb-2"
                >
                    <b-button @click="setModel(item)">
                        <b-img
                            thumbnail
                            fluid
                            :src="item.url"
                            alt="Image 1"
                        ></b-img>
                    </b-button>
                </b-col>
                <b-col v-if="!cleanedAttachments.length">
                    <h4 class="text-white">No Attachments Submitted</h4>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'attachments',

    mixins: [popupMixins],
    props: {
        order: {
            type: Object,
        },
    },
    data() {
        return {
            componentName: 'Service Attachment',
            submitting: false,
            model: null,
            isVisible: false,
            filelist: [],
            // attachment: null,
            // Controls Filepicker modal
            showModal: false,
        }
    },
    computed: {
        cleanedAttachments() {
            return ((this.order && this.order.attachments) || []).map(x => {
                if (x.url.indexOf(this.$OMSOldStorageUrl) === 0) {
                    x.url = x.url.replace(
                        this.$OMSOldStorageUrl,
                        this.$OMSStorageUrl
                    )
                }
                return x
            })
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    methods: {
        onSubmit() {
            event.preventDefault()

            console.log(this.filelist)
            this.uploadFile()
        },

        setModel(item) {
            console.log('item', item)
            this.model = {}
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isVisible = true
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
            const extension = newFile.name.split('.').pop() //extract

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },
        onChange(event) {
            const fileArray = [...event.target.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                }) //store selected files and additional data in our array
            })
        },
        remove(i) {
            this.filelist.splice(i, 1)
        },
        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChange()
        },
        uploadFile() {
            // console.log('upload event', event)
            let files = []

            for (const file of this.filelist) {
                files.push(file.file)
            }

            const $this = this
            if (!navigator.geolocation) {
                console.log('problem with navigator')

                this.genericToast(
                    this.componentName,
                    'Error',
                    'danger',
                    'Error Adding Attachment! Need Permissions to Get Coordinates'
                )

                // $this.doToast(
                //     'Error!',
                //     'Error Adding Attachment! Need Permissions to Get Coordinates',
                //     'danger'
                // )
            } else
                navigator.geolocation.getCurrentPosition(async p => {
                    try {
                        console.log('coordinates', p)
                        const lat = p.coords.latitude
                        const long = p.coords.longitude

                        const { key, name } = await $this.$store.dispatch(
                            's3files/s3upload',
                            files
                        )

                        const url = `${$this.$OMSStorageUrl}/${key}`
                        console.log({ key, name, url })

                        const payload = { url, lat, long }
                        payload.order_id = $this.order.id

                        await $this.$store.dispatch(
                            'customerPortal/createAttachment',
                            payload
                        )

                        $this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            $this.order.id
                        )
                        this.genericToast(
                            this.componentName,
                            'Uploaded',
                            'success',
                            `Attachment has been succcessfully uploaded`
                        )
                        // Hide modal after success
                        this.showModal = false
                        // $this.doToast(
                        //     'Image Added!',
                        //     'Attachment Added!',
                        //     'success'
                        // )
                    } catch (error) {
                        console.error('addAttachement', error)

                        $this.doToast(
                            'Error!',
                            'Error Adding Attachment!',
                            'danger'
                        )
                    } finally {
                        $this.submitting = false
                    }
                })
        },
        deleteAttachment(id) {
            const title = 'Delete Attachment?'
            const message = `Are you sure you want to delete this attachment?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return

                this.submitting = true
                const payload = {
                    order_id: this.order.id,
                    attachment_id: id,
                }

                this.$store
                    .dispatch('customerPortal/deleteAttachment', payload)
                    .then(() => {
                        this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            this.order.id
                        )

                        this.genericToast(
                            this.componentName,
                            'Deleted',
                            'success',
                            'Attachment deleted successfully'
                        )
                        // this.doToast(
                        //     'Deleted!',
                        //     'Attachment Deleted!',
                        //     'success'
                        // )
                        this.isVisible = false
                    })
                    .catch(error => {
                        console.error(error)

                        this.doToast(
                            'Error!',
                            'Error Deleting Attachment!',
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped></style>
